module.exports = __webpack_public_path__ + "assets/aaa4b5decc6bdb3428f53b8c9553691c.mp4";